import Model from '@/app/Model'
import { Permission } from '@/models/Permission'

export class Role extends Model {
	static fields () {
		return {
			id: null,
			name: null,
			department: null,
			departmentId: null,
			partnership: false,
			companyId: null,
			originDepartmentId: null
		}
	}

	static hasMany () {
		return {
			companyPermissions: Permission,
			departmentPermissions: Permission,
			distributorPermissions: Permission
		}
	}
}

export function createRole (data) {
	return Object.freeze(new Role(data))
}
